import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RoomProps } from './Room.props';
import { useAppDispatch } from '../../../../redux/store';
import { directoryActions } from '../../../../redux/directories/slice';
import { roomActions } from '../../../../redux/rooms/slice';
import { getRoomById } from '../../../../redux/rooms/asyncThunks';
import { DirectoryItem } from '../DirectoryItem';

export const Room: React.FC<RoomProps> = ({ room }) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const handleDeleteButtonClick = (id?: string | null) => {
        dispatch(directoryActions.setIsModalOpen());
        dispatch(roomActions.setIdToDelete(id));
    };

    const handleEditButtonClick = (id? : string | null) => {
        if (id) {
            navigate(`${id}/update`);
        }
    };

    return (
        <DirectoryItem
            item={room}
            handleEditButtonClick={handleEditButtonClick}
            handleDeleteButtonClick={handleDeleteButtonClick}
        />
    );
};
